import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { propertyService } from "../../_services";

Modal.setAppElement("#root");

const modalStyles = {
  overlay: {
    zIndex: 5,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    maxWidth: 500,
    minWidth: "30%",
    transform: "translate(-50%, -50%)",
  },
};

export default function CancelReservationModal({
  isOpen,
  bookingId,
  reservationId,
  onClose,
  onCancelled,
}) {
  const [cancelDate, setCancelDate] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setCancelDate("");
      setError("");
      setSubmitting(false);
    }
  }, [isOpen, bookingId]);

  const close = () => {
    if (!submitting) onClose();
  };

  const submit = async (event) => {
    event.preventDefault();
    setError("");

    if (!cancelDate) {
      setError("Enter a valid cancellation date in YYYY-MM-DD format.");
      return;
    }

    setSubmitting(true);
    try {
      const result = await propertyService.cancelBookingByDateAdmin(bookingId, cancelDate);
      onCancelled(result);
    } catch (requestError) {
      setError(requestError?.message || "Reservation cancellation could not be completed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={close}
      contentLabel="Cancel reservation"
      shouldCloseOnEsc={!submitting}
      shouldCloseOnOverlayClick={!submitting}
      style={modalStyles}
    >
      <form onSubmit={submit}>
        <div className="modal-header">
          <h5 className="modal-title">Cancel reservation</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close cancellation dialog"
            onClick={close}
            disabled={submitting}
          />
        </div>
        <div className="modal-body">
          <p>
            Reservation ID: <strong>{reservationId || bookingId}</strong>
          </p>
          <label
            htmlFor="admin-reservation-cancel-date"
            className="tw-block tw-mt-4 tw-mb-2 tw-font-semibold"
          >
            Cancellation date *
          </label>
          <input
            id="admin-reservation-cancel-date"
            name="cancelDate"
            type="date"
            className="form-control"
            value={cancelDate}
            onChange={(event) => setCancelDate(event.target.value)}
            disabled={submitting}
            required
          />
          {error && (
            <p role="alert" className="tw-mt-3 tw-text-red-600">
              {error}
            </p>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={close}
            disabled={submitting}
          >
            Keep reservation
          </button>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? "Cancelling..." : "Confirm cancellation"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
